import { useCallback, useEffect, useState } from "react"
import { get } from "helpers/api_helper"
import { getApiErrorMessage } from "helpers/api_error_helper"

const pendingPermissions = { user: null, loading: true, error: "" }

export default function useCurrentPermissions(errorMessage = "Unable to verify campaign permissions.") {
  const [permissions, setPermissions] = useState(pendingPermissions)
  const [requestVersion, setRequestVersion] = useState(0)

  const reload = useCallback(() => {
    setPermissions(pendingPermissions)
    setRequestVersion(version => version + 1)
  }, [])

  useEffect(() => {
    let active = true
    const fetchPermissions = async () => {
      try {
        const result = await get(process.env.REACT_APP_BACKEND_URL + "/v1/admin/account/session")
        if (result?.status !== "200" || !result.data || typeof result.data.scope !== "string") {
          throw new Error("Invalid account session response")
        }
        if (active) setPermissions({ user: result.data, loading: false, error: "" })
      } catch (error) {
        if (active) setPermissions({
          user: null,
          loading: false,
          error: getApiErrorMessage(error, errorMessage),
        })
      }
    }
    fetchPermissions()
    return () => { active = false }
  }, [requestVersion, errorMessage])

  const hasScope = useCallback(scope => (
    !permissions.loading && !permissions.error &&
    (permissions.user?.scope || "").split(/\s+/).includes(scope)
  ), [permissions])

  return { ...permissions, hasScope, reload }
}
